<template>
  <div>
    <van-popup v-model="show" :close-on-click-overlay="false">
      <template>
        <div class="content">
          <div class="load-row">
            <div>
              <img
                src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=100"
                alt="Avatar"
              />
            </div>
            <div>
              <img
                src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=100"
                alt="Avatar"
              />
            </div>
            <div>
              <img
                src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=100"
                alt="Avatar"
              />
            </div>
            <div>
              <img
                src="https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&w=100"
                alt="Avatar"
              />
            </div>
            <div>
              <img
                src="https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?auto=format&fit=crop&w=100"
                alt="Avatar"
              />
            </div>
          </div>
          <p>
            Processing your loan application <br />
            – this may take about 8-10 seconds.
          </p>
        </div>
      </template>
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      show: true
    }
  }
}
</script>

<style scoped lang="less">
.van-popup {
  font-size: 14px;
  color: #12033a;
  line-height: 18px;
  font-weight: 500;
  border-radius: 20px;
  padding: 60px 16px 25px;
  p {
    margin-top: 32px;
  }
  /* 加载动画样式 */
  .load-row {
    width: 280px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    margin: 0 auto;
    position: relative;
  }

  .load-row div {
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 50px;
    margin: 0 15px;
  }

  .load-row div img {
    width: 28px;
    height: 28px;
    border-radius: 12px;
    object-fit: cover;
    display: block;
  }

  /* 动画定义 */
  @keyframes up-down {
        0% {
          transform: translateY(0);
        }

        100% {
          transform: translateY(-15px);
        }
      }

      @keyframes down-up {
        0% {
          transform: translateY(0);
        }

        100% {
          transform: translateY(15px);
        }
      }

      @keyframes scale-animation {
        0% {
          transform: scale(0);
        }

        100% {
          transform: scale(1);
        }
      }

      /* 为每个元素应用动画 */
      /* 第1个元素 - 与[2,4]相位相反（延迟1.0s半周期），实现严格交替起跳 */
      .load-row div:nth-child(1) img {
        animation: up-down 1s infinite alternate ease-in-out;
        animation-delay: 1.6s; /* 0.6s 基础延迟 + 1.0s 半周期相位差 */
      }

      /* 第2个元素 - 延迟后上下浮动 */
      .load-row div:nth-child(2) img {
        animation: up-down 1s infinite alternate ease-in-out;
        animation-delay: 0.6s;
      }

      /* 第3个元素 - 与[2,4]相位相反（延迟1.0s半周期），实现严格交替起跳 */
      .load-row div:nth-child(3) img {
        animation: up-down 1s infinite alternate ease-in-out;
        animation-delay: 1.6s; /* 0.6s 基础延迟 + 1.0s 半周期相位差 */
      }

      /* 第4个元素 - 先缩放，然后上下浮动 */
      .load-row div:nth-child(4) img {
        transform: scale(0);
        animation: scale-animation 0.3s forwards ease-in-out,
          up-down 1s infinite alternate ease-in-out 0.6s;
      }

      /* 第5个元素 - 延迟后缩放，然后与[2,4]相位相反（延迟1.0s半周期）的上下浮动 */
      .load-row div:nth-child(5) img {
        transform: scale(0);
        animation: scale-animation 0.3s 0.3s forwards ease-in-out,
          up-down 1s infinite alternate ease-in-out 1.6s; /* 0.6s 基础延迟 + 1.0s 半周期相位差 */
      }
}
</style>
